(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["winyel-minimal-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.wmp').forEach((section) => {
    const hero = section.querySelector('.wmp__hero-image');
    const quantity = section.querySelector('[data-quantity]');
    const addButton = section.querySelector('.wmp__add');
    section.querySelectorAll('.wmp__thumb').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!hero) return;
        hero.src = thumb.dataset.imageUrl;
        hero.alt = thumb.dataset.imageAlt;
        section.querySelectorAll('.wmp__thumb').forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-pressed', 'true');
      });
    });
    section.querySelector('[data-sticky-add]')?.addEventListener('click', () => addButton?.click());
    const planInput = section.querySelector('[data-selling-plan]');
    const planSelect = section.querySelector('[data-plan-select]');
    const planPicker = section.querySelector('.wmp__plan-picker');
    section.querySelectorAll('input[name^="purchase_option_"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        section.querySelectorAll('.wmp__purchase-option').forEach((option) => option.classList.remove('is-selected'));
        radio.closest('.wmp__purchase-option')?.classList.add('is-selected');
        const subscribing = radio.value === 'subscription';
        if (planPicker) planPicker.hidden = !subscribing;
        if (planInput) planInput.value = subscribing ? planSelect?.value || '' : '';
        const supplyOptions = section.querySelector('[data-supply-options]');
        if (supplyOptions) supplyOptions.hidden = subscribing;
        if (subscribing && quantity) quantity.value = '1';
      });
    });
    planSelect?.addEventListener('change', () => {
      if (planInput) planInput.value = planSelect.value;
    });
    section.querySelectorAll('input[name^="supply_"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        section.querySelectorAll('.wmp__supply-card').forEach((card) => card.classList.remove('is-selected'));
        radio.closest('.wmp__supply-card')?.classList.add('is-selected');
        if (quantity) quantity.value = radio.value;
        if (addButton) addButton.textContent = `Add ${radio.value} ${radio.value === '1' ? 'bottle' : 'bottles'} to cart`;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["winyel-subscribe-save"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('winyel-subscribe-builder')) {
    class WinyelSubscribeBuilder extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('[data-product-card]'));
        this.frequencyGrid = this.querySelector('[data-frequency-grid]');
        this.summary = this.querySelector('[data-summary]');
        this.benefitPanel = this.querySelector('[data-benefit-panel]');
        this.products = this.cards.map((card) => {
          const product = JSON.parse(card.querySelector('[data-product-json]').textContent);
          product.card = card;
          product.image = card.querySelector('img')?.src || '';
          return product;
        });
        this.state = { productIndex: 0, optionIndex: 1 };
        this.benefits = {
          'magnesium-supplement-complex': [['90','90 vegan capsules'],['45','45 label servings'],['8','Eight magnesium forms'],['📄','Review label before use']],
          'urolithin-a-longevity-gummies': [['60','60-count gummy format'],['CoQ10','Includes CoQ10'],['UA','Urolithin A formula'],['📄','Review product label']],
          'soursop-bitters-liquid-organic-herbal-guanabana-detox-with-black-seed-moringa-ginger-supports-digestive-wellness-immune-function': [['🌿','Herbal wellness'],['🛡️','Immune support'],['🫚','Digestive balance'],['💧','Daily ritual']],
          'spicy-cubes-hot-peach-gummies': [['🍑','Hot peach flavor'],['🔥','Sweet heat'],['😋','Easy daily chew'],['✨','Playful wellness']],
          'areds-2-eye-vitamin-mineral-supplement-with-ocusorb-120-vegan-soft-gels-contains-lutein-zeaxanthin-vitamin-c-e-zinc-copper-eye-health-supplements': [['👁️','Eye health'],['🌼','Lutein + zeaxanthin'],['🛡️','Antioxidant support'],['🌱','Vegan softgels']],
          'soursop-bitters-liquid-drops-with-sea-moss-moringa-turmeric-black-seed-oil-oregano-ashwagandha-herbal-extracts-for-overall-health-enhancing-vegan-non-gmo-2-fl-oz': [['🌊','Sea moss blend'],['🌿','Botanical support'],['💧','Easy liquid format'],['🛡️','Daily wellness']],
          'apple-cider-vinegar-gummies-formulated-to-support-normal-energy-levels-gut-health-supports-digestion-detox-cleansing-acv-gummies-w-vit-b12-dietary-edible-fitness': [['🍎','Apple cider vinegar'],['🫚','Digestive support'],['🔋','Daily energy'],['✨','Easy routine']],
          'hair-soft-chews-hair-vitamins-for-women-and-men-with-biotin-advanced-formula-for-hair-mixed-berry-60-soft-chews': [['💇','Hair support'],['✨','10,000mcg biotin'],['🍓','Mixed berry chews'],['🌿','Beauty routine']],
          'creatine-monohydrate-gummies-for-men-women-sugar-free-creatine-gummy-5g-per-serving-berry-flavor-36-gummies': [['💪','Muscle strength'],['🔋','Workout power'],['🏃','Performance'],['🍓','Sugar-free berry']],
          'cayenne-pepper-softgel-supplement-to-support-leg-vein-heart-and-vascular-health-contains-vitamins-c-d3-and-k2-grape-seed': [['❤️','Heart support'],['🦵','Leg vein support'],['🩸','Healthy circulation'],['🔋','Daily vitality']]
        };
        this.cards.forEach((card, index) => card.querySelector('button')?.addEventListener('click', () => this.selectProduct(index)));
        if (this.products.length) this.render();
      }

      get product() { return this.products[this.state.productIndex]; }
      get options() {
        if (!this.product) return [];
        const plans = this.product.plans.map((plan) => ({ ...plan, isSubscription: true }));
        plans.push({ id: null, name: 'One-time purchase', price: this.product.price, compareAtPrice: this.product.compareAtPrice, isSubscription: false });
        return plans;
      }
      get option() { return this.options[Math.min(this.state.optionIndex, this.options.length - 1)]; }
      money(cents) { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100); }
      discountPercent(option) { return option.isSubscription && this.product.price ? Math.max(0, Math.round((this.product.price - option.price) / this.product.price * 100)) : 0; }

      transition(callback) {
        if (document.startViewTransition) document.startViewTransition(callback);
        else callback();
      }

      selectProduct(index) {
        this.transition(() => {
          this.state.productIndex = index;
          this.state.optionIndex = this.product.plans.length > 1 ? 1 : 0;
          this.render();
        });
      }

      selectOption(index) {
        this.transition(() => {
          this.state.optionIndex = index;
          this.renderFrequencies();
          this.renderSummary();
        });
      }

      render() {
        this.cards.forEach((card, index) => {
          const active = index === this.state.productIndex;
          card.classList.toggle('is-active', active);
          const button = card.querySelector('button');
          if (button && !button.disabled) {
            button.setAttribute('aria-pressed', String(active));
            button.textContent = active ? 'Selected' : 'Select product';
          }
        });
        this.renderBenefits();
        this.renderFrequencies();
        this.renderSummary();
      }

      renderBenefits() {
        const benefits = this.benefits[this.product.handle] || [['🌿','Daily wellness'],['🛡️','Quality tested'],['✨','Easy routine'],['📅','Consistent support']];
        this.benefitPanel.innerHTML = `<div><h3>Why ${this.product.title}?</h3><p>Four feel-good reasons to keep this one in your routine.</p></div><div class="wy-benefit-list">${benefits.map(([icon,label]) => `<div><span>${icon}</span><strong>${label}</strong></div>`).join('')}</div>`;
      }

      renderFrequencies() {
        this.frequencyGrid.innerHTML = this.options.map((option, index) => {
          const active = index === this.state.optionIndex;
          const discount = this.discountPercent(option);
          return `<button type="button" class="wy-frequency-card ${active ? 'is-active' : ''} ${option.isSubscription && index === 1 ? 'is-popular' : ''}" role="radio" aria-checked="${active}" data-option-index="${index}"><span class="wy-frequency-card__top"><h3>${option.name}</h3><span class="wy-frequency-card__badge">${discount ? `SAVE ${discount}%` : 'NO AUTOSHIP'}</span></span><p>${option.isSubscription ? 'Automatic recurring delivery' : 'Try it once, no recurring charge'}</p><span class="wy-frequency-card__check">${active ? 'Selected' : 'Choose this plan'}</span></button>`;
        }).join('');
        this.frequencyGrid.querySelectorAll('[data-option-index]').forEach((button) => button.addEventListener('click', () => this.selectOption(Number(button.dataset.optionIndex))));
      }

      renderSummary() {
        const option = this.option;
        const regular = this.product.compareAtPrice || this.product.price;
        const planSavings = Math.max(0, this.product.price - option.price);
        const totalSavings = Math.max(0, regular - option.price);
        this.summary.innerHTML = `<p class="wy-summary__label">Your ${option.isSubscription ? 'subscribe & save' : 'one-time'} plan</p><div class="wy-summary__product"><img src="${this.product.image}" alt=""><div><h3>${this.product.title}</h3><p>${option.name}${option.isSubscription ? ' · Subscription' : ''}</p></div></div><div class="wy-math-row"><span>Regular price</span><strong>${this.money(regular)}</strong></div><div class="wy-math-row"><span>WINYEL price</span><strong>${this.money(this.product.price)}</strong></div><div class="wy-math-row wy-math-row--discount"><span>Plan discount</span><strong>−${this.money(planSavings)}</strong></div><div class="wy-total"><span>Total today</span><strong>${this.money(option.price)}</strong></div><p class="wy-savings">You save ${this.money(totalSavings)} vs. regular price 🎉</p><button type="button" class="wy-button" data-add-plan ${this.product.available ? '' : 'disabled'}>${option.isSubscription ? 'Add subscription to cart' : 'Add to cart'} →</button><p class="wy-summary__fine">🛡️ 30-day money-back guarantee. ${option.isSubscription ? 'Pause, skip, or cancel according to the subscription policy.' : 'No recurring charge.'}</p><p class="wy-cart-error" data-cart-error role="alert"></p>`;
        this.summary.querySelector('[data-add-plan]')?.addEventListener('click', () => this.addToCart());
      }

      async addToCart() {
        const button = this.summary.querySelector('[data-add-plan]');
        const error = this.summary.querySelector('[data-cart-error]');
        const option = this.option;
        const item = { id: this.product.variantId, quantity: 1 };
        if (option.isSubscription) item.selling_plan = option.id;
        button.disabled = true;
        button.textContent = 'Adding…';
        error.textContent = '';
        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [item] })
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || 'This item could not be added.');
          window.location.href = `${window.Shopify.routes.root}cart`;
        } catch (requestError) {
          error.textContent = requestError.message;
          button.disabled = false;
          button.textContent = option.isSubscription ? 'Add subscription to cart →' : 'Add to cart →';
        }
      }
    }
    customElements.define('winyel-subscribe-builder', WinyelSubscribeBuilder);
  }

  } catch(e) { console.error(e); }
})();
})();
